export default class pegPhotoUploader extends HTMLElement {
	connectedCallback() {}

	async startPhotoUpload(photo, photoDescription) {
		try {
			this.#show();
			this.#trackUploadProcessStarted();
			await this.#post(photo, photoDescription);
			this.#trackUploadProcessFinished();
			this.#handleSuccess();
			this.#hide();
		} catch (error) {
			if (error.type === 'max_photos_reached') {
				this.dispatchEvent(new CustomEvent('pegPhotoUploader:maxPhotosReached', { detail: error.error, bubbles: true }));
			} else {
				this.dispatchEvent(new CustomEvent('pegPhotoUploader:uploadFailed', { detail: error.error, bubbles: true }));
			}
		}
	}

	#handleSuccess() {
		this.dispatchEvent(new CustomEvent('pegPhotoUploader:uploadSuccess', { bubbles: true }));
	}

	#show() {
		this.removeAttribute('hidden');
	}

	#hide() {
		this.setAttribute('hidden', '');
	}

	async #post(photo, photoDescription) {
		const uploadProgressBar = this.querySelector('#uploadProgressBar');
		const csrfToken = jPar.wdk.security.csrf.getToken();
		const creationDate = this.closest('peg-photo-selector')?.creationDate || '';
		const formData = new FormData();

		formData.append('file', photo, 'image.jpeg');
		formData.append('caption', photoDescription);
		formData.append('creationDate', creationDate);

		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			uploadProgressBar.setAttribute('aria-live', 'assertive');
			uploadProgressBar.setAttribute('aria-busy', 'true');
			uploadProgressBar.setAttribute('aria-atomic', 'true');

			xhr.upload.addEventListener('progress', (event) => {
				const { lengthComputable, loaded, total } = event;
				if (lengthComputable) {
					const percentage = (loaded / total) * 100;
					uploadProgressBar.value = percentage;
					uploadProgressBar.setAttribute('aria-valuenow', percentage);
				}
			});

			xhr.addEventListener('loadend', () => {
				uploadProgressBar.setAttribute('aria-busy', 'false');

				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						resolve();
						return;
					}

					uploadProgressBar.value = 0;
					uploadProgressBar.removeAttribute('aria-valuenow');
					this.#hide();
					if (xhr.responseText?.includes('Maximum number of photos reached')) {
						reject({ error: new Error('Maximum number of photos reached'), type: 'max_photos_reached' });
					} else {
						reject({ error: new Error(`server error:${xhr.status}`), type: '500' });
					}
				}
			});

			xhr.open('POST', '/photos', true);
			xhr.setRequestHeader('x-csrf-token', csrfToken);
			xhr.send(formData);
		});
	}

	#trackUploadProcessStarted() {
		jPar.util.log.bigData({
			category: this.getAttribute('tracking-category'),
			subcategory: this.getAttribute('tracking-subcategory'),
			targetId: 'button_upload',
			action: 'upload_started',
		});
	}

	#trackUploadProcessFinished() {
		jPar.util.log.bigData({
			category: this.getAttribute('tracking-category'),
			subcategory: this.getAttribute('tracking-subcategory'),
			action: 'upload_finished',
		});
	}
}
